import * as React from 'react'
import { connect } from 'react-redux'
import { back } from '../../actions/navigation'
import { close } from '../../actions/index'
import { strings } from '../../lib/localization'
import { currentNavigatorStackSelector } from '../../selectors/navigation'
import Tooltip from 'react-simple-tooltip'
import { RootState } from '../../types/rootstate'
import EscapeHandler from '../../lib/escape-handler'

import '../../sass/forms/header.scss'

interface StateProps {
  currentNavigationStack: RootState['navigation']['navigationStacks']['key']['history']
}

interface DispatchProps {
  goBack: () => void
  close: () => void
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface OwnProps {}

type HeaderProps = StateProps & DispatchProps & OwnProps

function mapStateToProps(state: RootState): StateProps {
  return {
    currentNavigationStack: currentNavigatorStackSelector(state)
  }
}

function mapDispatchToProps(dispatch): DispatchProps {
  return {
    goBack: () => dispatch(back()),
    close: () => dispatch(close())
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface HeaderState {}

class HeaderComponent extends React.Component<HeaderProps, HeaderState> {
  headerRef = React.createRef<HTMLDivElement>()

  componentDidMount() {
    this.headerRef.current.focus()
    EscapeHandler.registerEscapeListener(this.handleEscape)
  }

  componentWillUnmount() {
    EscapeHandler.removeEscapeListener(this.handleEscape)
  }

  handleEscape = () => {
    this.props.close()
  }

  handleBackClick = (e: React.MouseEvent<HTMLLIElement>) => {
    this.props.goBack()
  }

  handleBackKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      this.props.goBack()
    }
  }

  handleCloseClick = (e: React.MouseEvent<HTMLElement>) => {
    this.props.close()
  }

  handleCloseKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      this.props.close()
    }
  }

  render() {
    const navigation = this.props.currentNavigationStack.filter(
      (history) => history.module !== 'hub'
    )

    const hasBackButton = navigation.length > 1
    const navigationToString = navigation
      .map((history) => history.name)
      .join(' -> ')

    return (
      <div ref={this.headerRef}>
        <header className='accentPrimary'>
          {hasBackButton && (
            <div className='back-button'>
              <i
                tabIndex={0}
                role='button'
                aria-label={strings.a11yHeaderBack}
                onClick={this.handleBackClick}
                onKeyDown={this.handleBackKeyDown}
                className='material-icons'
              >
                arrow_back
              </i>
            </div>
          )}

          <div className='header-title'>
            <div className='header-title-agentName'>
              {strings.contactFormHeader}
            </div>
            {/* <div className="header-title-department">Kundtjänstmedarbetare {navigationToString}</div>**/}
          </div>

          <div className='close-button'>
            <Tooltip
              content={strings.minimizeWindow}
              fontSize='12px'
              padding={6}
              radius={4}
              placement='left'
              fadeDuration={350}
              fadeEasing='ease'
              background='#1c1c1c'
              border='#1c1c1c'
            >
              <i
                tabIndex={0}
                role='button'
                aria-label={strings.a11yHeaderClose}
                className='icon-close material-icons'
                onClick={this.handleCloseClick}
                onKeyDown={this.handleCloseKeyDown}
              >
                keyboard_arrow_down
              </i>
            </Tooltip>
          </div>
        </header>
      </div>
    )
  }
}

const Header = connect<StateProps, DispatchProps, OwnProps>(
  mapStateToProps,
  mapDispatchToProps
)(HeaderComponent)

export { Header }
